import { TweenMax } from "gsap";
import { Size, Log, Geometry, Rect, HorizontalAlign, VerticalAlign, LogGroup, CreateSpineResources, Scale } from "../MyHelpers";
import { AudioManager, ITrack, Track } from "../AudioManager";
import { MyCanvas } from "./MyCanvas";
import { Sprite } from "./Sprite/Sprite";
import { ZIndex } from "../ZIndex";
import { SlotGameBet } from "../api";
import * as PIXI from "pixi.js";
import { Resourceful } from "../ResourceManager/Resourceful";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../ResourceManager/ResourceManager";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { Settings } from "../Settings";
import { IWinMessage } from "./WinMessage";
import { AtlasResource } from "../ResourceManager/AtlasResource";
import { JSONResource } from "../ResourceManager/JSONResource";
import { ISkeletonData, Spine } from "pixi-spine";

export class WinMessagePIXIAPP
{
	public name: string;
	//public sprite: Sprite;
	public minCreditMultiplier: number;
	public audioTrack: ITrack = null;
	protected spriteTexture : PIXI.Texture[] = [];
	protected jsonSpine : any = null;
	public spine : Spine = null;
	
	public constructor(name: string, minCreditMultiplier: number,  jsonSpine : any) {
		this.name = name;	
		this.minCreditMultiplier = minCreditMultiplier;
		//this.audioTrack = audioTrack;
		this.jsonSpine = jsonSpine;
	}

	public CreateElementPIXIAPP(){
		this.spine = CreateSpineResources(this.jsonSpine.spineData);
		this.spine.scale.set(1,1);
		this.spine.pivot.set(this.spine.width/2,this.spine.height/2);
		//this.spine.visible = false;		
		return this.spine;		
	}
	public SetAudio(audio : ITrack){
		this.audioTrack = audio;
	}
}

export class WinMessageAnimationPIXIAPP implements Resourceful
{

	protected wins: IWinMessage[] = [
		{name: "big", winMultiplier: 10,file: "BigWin"},
		{name: "great", winMultiplier: 20, file: "GreatWin"},
		{name: "huge", winMultiplier: 30, file: "HugeWin"},
		{name: "awesome", winMultiplier: 40, file: "AwesomeWin"},
		{name: "amazing", winMultiplier: 50, file: "AmazingWin"}
	];

	//private screenSize: Size = null;
	//private canvas: MyCanvas = null;

	private winMessages: WinMessagePIXIAPP[] = [];

	private running: boolean = false;
	private runningMessage: WinMessagePIXIAPP = null;


	private anim_zoomIn: any;	// TweenMax
	public myscale: number = 0;

	private logGroup: string = "WinMessageAnimation";
	protected audio : AudioManager = null;

	public constructor(audio : AudioManager) {
		this.audio = audio;
		//this.screenSize = screenSize;	
		this.anim_zoomIn = TweenMax.fromTo(this, 1, {myscale: 0}, {myscale: 0.8, paused: true});
	}	
	
	public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
		//throw new Error("Method not implemented.");
		// message
		for (let i = 0; i < this.wins.length; i++) {
			resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/WinMessages/${this.wins[i].file}/${this.wins[i].file}.json`,ResourceIdentifier.Global.ScopedResourceName(`winmsg-json-$${this.wins[i].file}`), true));
			resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/common/resources/BonusResorucesSpine/WinMessages/${this.wins[i].file}/${this.wins[i].file}.atlas`, ResourceIdentifier.Global.ScopedResourceName(`winmsg-altas-$${this.wins[i].file}`), true));
			//this.audio.AddTrack(new Track(Settings.ResourcesFolder + "multigame/slot/common/resources/voice/"+this.wins[i].name  + Settings.audioFormat, ResourceIdentifier.Global.ScopedResourceName("Sound-WinMessage"+this.wins[i].name),true));
		}
	}

	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
		//throw new Error("Method not implemented.");
		// messages
		for (let i = 0; i < this.wins.length; i++) {
		let winmsgjson = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`winmsg-json-$${this.wins[i].file}`));
		let winmsgjsonspine = await PIXI.Assets.load(winmsgjson.path);
		//let audio =   this.audio.Track(ResourceIdentifier.Global.ScopedResourceName(this.wins[i].name))
		//audio.PlayLoop(Track.LoopForEver);
		let message = new WinMessagePIXIAPP(this.wins[i].name,this.wins[i].winMultiplier,winmsgjsonspine);
			this.AddMessage(message);
		}
	}

	// make sure messages are added smallest to biggest
	public AddMessage(winMessage: WinMessagePIXIAPP) {
		if (this.winMessages.length > 0 && 
			this.winMessages[this.winMessages.length -1].minCreditMultiplier > winMessage.minCreditMultiplier
		)
		{
			Log.Error(this.logGroup, "Make sure win messages are added from smallest to biggest");
		}

		this.winMessages.push(winMessage);		
	}


	public AddSound(nameWin: string, audio: ITrack) {
		this.winMessages.forEach(message => {
			if (message.name == nameWin) {
				message.SetAudio(audio);
			}
		})
	}

	public WillTrigger(bet: SlotGameBet, winCredit: number): boolean {
		
		let winMultiplier = winCredit / bet.TotalBetCredits;

		// smallest win message is first, co we can check just this one
		if (this.winMessages.length > 0 &&
			this.winMessages[0].minCreditMultiplier <= winMultiplier) {
			return true;
		}

		return false;
	}

	public Start(bet: SlotGameBet, winCredit: number): boolean {
		let winMultiplier = winCredit / bet.TotalBetCredits;
		// find message to run
		// the message is first one, that has lower min threshold than win credit
		// find it by running backwards, so we get the biggest, that satisfies criteria
		let messageToRun: WinMessagePIXIAPP = null;
		for (let i = this.winMessages.length -1; i >= 0; i--) {
			if (winMultiplier >= this.winMessages[i].minCreditMultiplier) {
				messageToRun = this.winMessages[i];
				break;
			}
		}

		if (messageToRun != null) {
			this.runningMessage = messageToRun;
			this.viewPIXIAPP.visible = true;
			this.runningMessage.spine.visible = true;
			this.runningMessage.spine.state.setAnimation(0,"animation",true);
			
			if (this.runningMessage.audioTrack != null)
			{
				this.runningMessage.audioTrack.Play();
			}

			this.running = true;
		}

		this.anim_zoomIn.restart();
		//this.canvas.view.style.visibility = "visible";

		return this.running;
	}

	public IsRunning(): boolean {
		return this.running;
	}

	public Stop() {
		this.running = false;
		this.anim_zoomIn.kill();
		//this.canvas.view.style.visibility = "hidden";
		if(this.runningMessage != null){
			this.runningMessage.spine.visible = false
			this.viewPIXIAPP.visible = false;
			this.runningMessage.spine.state?.clearTracks();
		}
		
		

/*
		if (this.runningMessage!= null && 
			this.runningMessage.audioTrack != null)
		{
			this.runningMessage.audioTrack.Stop();
		}
*/
	}

	public Update() {
		// if (this.running) {
		// 	this.runningMessage.sprite.Update();

		// 	//if (this.runningMessage.sprite.FrameChanged() ) {
		// 		let dstRect = Geometry.FitRect(this.runningMessage.sprite.CurrentFrameRect, Rect.FromSize(this.screenSize), HorizontalAlign.Center, VerticalAlign.Center);
				

		// 		//this.canvas.context.save();

		// 		// applied in reverse order
		// 		this.canvas.context.resetTransform();
		// 		this.canvas.Clear();
		// 		this.canvas.context.translate(0.5 * dstRect.width, 0.5 * dstRect.height);
		// 		this.canvas.context.scale(0.5, 0.5);
		// 		this.canvas.context.translate(-0.5 * dstRect.width, -0.5 * dstRect.height);

		// 		this.runningMessage.sprite.Update();
		// 		this.canvas.DrawImage(this.runningMessage.sprite.CurrentFrame, this.runningMessage.sprite.CurrentFrameRect, dstRect);
		// 		//this.canvas.Canvas()
		// 		//this.canvas.context.restore();
		// 	//}
		// }
	}

	public View() {
		return null;
	}

	protected viewPIXIAPP: PIXI.Container;
	public CreatePIXIAPP() {
		this.viewPIXIAPP = new PIXI.Container();
		//this.viewPIXIAPP.position.set(Settings.ScreenWidth / 2, Settings.Enable2plus1 == true ? (Settings.ScreenHeight + (Settings.ScreenHeight / 2.5))  :  Settings.ScreenHeight * (Settings.Screens - 1));
		this.viewPIXIAPP.name = "WinMessageAnimationPIXIAPP";
		this.winMessages.forEach(element => {
			let view = element.CreateElementPIXIAPP();
			//view.state.setAnimation(0,"animation",true);
			this.viewPIXIAPP.addChild(view);
		});
		// this.viewPIXIAPP.position.set(Settings.ScreenWidth / 2, Settings.ScreenHeight * Settings.Screens - Scale.H(608));
		this.viewPIXIAPP.visible = false;

		this.winMessages.forEach(element => { element.spine.visible = false });
		this.OnResize();
	}

	protected OnResize(): void{
		this.setToDefault();
		const scaleX = 1041 / 1920;
		// const scaleY = 268 / 1080;
		// const scale = Math.min(scaleX, scaleY);
		this.viewPIXIAPP.scale.set(scaleX);

		this.viewPIXIAPP.position.x = Scale.W(1920) / 2;
		this.viewPIXIAPP.position.y = Scale.H(1080) / 2 - this.viewPIXIAPP.height / 2;

	}

	private setToDefault() {
		this.viewPIXIAPP.position.set(0, 0);
		this.viewPIXIAPP.scale.set(1);

	}
	public ViewPIXIAPP() {
		return this.viewPIXIAPP;
	}
}